import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "~/components/ui/breadcrumb";
import useNextGenHeader from "~/contexts/nextgen-header";
import { cn } from "~/lib/utils";

export function ManifoldNextGenAppHeader() {
  const { breadcrumbs, title, actions, rightPane } = useNextGenHeader();
  const navigate = useNavigate();

  // With a rightPane, add a fourth column that auto-sizes to the pane's
  // intrinsic width (the pane controls its own width via classNames). The two
  // 1fr columns then balance the title in the remaining space, so it shifts
  // when the pane's width changes.
  const gridCols = rightPane ? "grid-cols-[1fr_auto_1fr_auto]" : "grid-cols-[1fr_auto_1fr]";

  return (
    <div className={cn("grid shrink-0 items-stretch border-b border-border", gridCols)}>
      <div className="flex items-center py-3 pl-6">
        {breadcrumbs.length > 0 ? (
          <Breadcrumb>
            <BreadcrumbList>
              {breadcrumbs.map((crumb, index) => {
                const isLast = index === breadcrumbs.length - 1;
                return (
                  <Fragment key={index}>
                    <BreadcrumbItem>
                      {isLast || !crumb.href ? (
                        <BreadcrumbPage>{crumb.label}</BreadcrumbPage>
                      ) : (
                        <BreadcrumbLink
                          href={crumb.href}
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(crumb.href!);
                          }}
                        >
                          {crumb.label}
                        </BreadcrumbLink>
                      )}
                    </BreadcrumbItem>
                    {!isLast && <BreadcrumbSeparator />}
                  </Fragment>
                );
              })}
            </BreadcrumbList>
          </Breadcrumb>
        ) : (
          title && <span className="text-base font-medium text-foreground">{title}</span>
        )}
      </div>

      <div className="flex items-center justify-center px-4 py-3">
        {breadcrumbs.length > 0 && title && (
          <span className="text-sm font-medium text-foreground">{title}</span>
        )}
      </div>

      <div className="flex items-center justify-end gap-2 py-3 pr-6">
        {actions[0]}
        {actions[1]}
      </div>
      {rightPane}
    </div>
  );
}
